﻿{
  "boardmakerHome": "Boardmaker-aloitussivu",
  "subscription": "Tilaus",
  "change": "Vaihda",
  "currency": "USD",
  "save": "Säästä",
  "save17Percent": "<strong>Säästä {{percent}}%</strong> vuosittaisen tilaussuunnitelman kanssa",
  "save17PercentNoBold": "Säästä {{percent}}%",
  "yearly": "Vuosittain",
  "monthly": "Kuukausittain",
  "Lifetime": "Elinaika",
  "PerMonth": "Kuukautta kohti",
  "PerYear": "Vuotta kohti",
  "Free": "Vapaa",
  "optional": "valinnainen",
  "trialLengthTrial": "<0>{{ trialLength }}</0>-päivän koekäyttö",
  "viewAllPlans": "Tarkastele kaikkia suunnitelmia",
  "myBoardmaker": "Oma Boardmaker",
  "canada": "Kanada",
  "unitedStates": "Yhdysvallat",
  "oneMomentPlease": "Hetkinen...",
  "software": "Ohjelmisto",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Valmis",
  "loadingRegions": "Lataa saatavana olevia alueita",
  "loadingPartners": "Lataa saatavana olevia kumppaneita",
  "supportedPeripherals": "Tuetut oheislaitteet",
  "pleaseWait": "Odota...",
  "minimum": "Minimi",
  "recommended": "Suositellaan",
  "browser": "Selain",
  "tobiiDynavoxEyeTrackers": "Tobii Dynavox Eye Trackers",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "tarvitsetko apua valitessa",
  "or": "tai",
  "advantages": "Edut",
  "visitPartnerSite": "Vieraile kumppanuussivustolla",
  "recentOrders": "Viimeiset tilaukset",
  "current": "nykyinen",
  "orLater": "tai myöhempi",
  "customerSupport": "asiakastuki",
  "proratedAmount": "Suhteutettu määrä",
  "community": {
    "community": "Yhteisö",
    "getStartedNow": "Aloita heti!"
  },
  "personal": "Henk.koht.",
  "professional": "Ammatillinen",
  "planCard": {
    "noCCRequired": "Luottokorttia ei vaadita",
    "cCOnly": "Vain luottokortti",
    "cCOrPO": "Luottokortti tai hankintatilaus",
    "myPlan": "Oma suunnitelma",
    "currentPlan": "Nykyinen suunnitelma",
    "downgradeNotice": "Muutos tulee voimaan, kun nykyinen suunnitelma vanhenee.",
    "upgradeNotice": "Muutos tulee voimaan välittömästi."
  },
  "selectedPlanSummary": {
    "summary": "Tiivistelmä",
    "change": "$t(muutos)",
    "subtotal": "Välisumma"
  },
  "action": {
    "joinToday": "Liity tänään!",
    "finish": "Lopetus",
    "subscribe": "Tilaa",
    "resubscribe": "Tilaa uudelleen",
    "requestAQuote": "Pyydä tarjous",
    "try": "Yritä",
    "startTrial": "Aloita koekäyttö",
    "buyNow": "Osta heti",
    "tryIt": "Kokeile",
    "tryItFree": "Kokeile maksutta 30 päivän ajan!",
    "free": "maksuton",
    "getStarted": "Aloita",
    "forTrialDays": "<1>{{trialLength}}</1> päivän ajan",
    "comparePlans": "Vertaa suunnitelmia",
    "hideComparisons": "Piilota vertailukohteet",
    "learnMore": "Katso lisätietoja",
    "start": "Aloita",
    "next": "Seuraava",
    "edit": "Muokkaa",
    "cancel": "Peruuta",
    "imTaxExempt": "Verovapaus",
    "submit": "Lähetä",
    "print": "Tulosta",
    "backToPaymentDetails": "Takaisin maksutietoihin",
    "close": "Sulje",
    "back": "Takaisin",
    "continue": "Jatka",
    "uploading": "Ladataan",
    "delete": "Poista",
    "update": "Päivitä",
    "generatingInvoice": "Laskun tuotto",
    "proceed": "Jatka",
    "modify": "Muokkaa",
    "yes": "Kyllä",
    "signUp": "Rekisteröidy käyttäjäksi",
    "downloads": "Lataukset"
  },
  "status": {
    "loading": "Lataa...",
    "creatingAccount": "Luodaan tiliä….",
    "submitting": "Lähetetään...",
    "submittingPayment": "Lähetetään maksua...",
    "submittingRequest": "Lähetetään pyyntöä..."
  },
  "planComparison": {
    "label": "Mitkä ovat ominaisuuksien edut kussakin tilaussuunnitelmassa?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Ominaisuuksien vertailu",
    "subheader": "Maailman suosituin ratkaisu loputtomia symbolipohjaisia viestimisiä ja visuaalisia tukia varten!"
  },
  "account": {
    "email": "Sähköposti",
    "accountFoundTitle": "Tili löydetty",
    "accountFoundMessage": "Tili tällä sähköpostiosoitteella on jo olemassa. Haluatko kirjautua sisään käyttämällä kyseistä tiliä tai käyttämällä eri sähköpostiosoitetta ja luoden uuden tilin?",
    "signedOutElsewhereTitle": "Sinut on kirjattu ulos",
    "signedOutElsewhereMessage": "Sinut kirjattiin ulos toisessa välilehdessä. Kirjaudu uudelleen sisään jatkaaksesi, tai sulje tämä selataksesi ilman tiliä.",
    "signedOutElsewhereDismiss": "Jatka selaamista",
    "federatedEmailTitle": "Organisaation sähköposti tunnistettu",
    "federatedEmailMessage": "Tämä sähköpostiosoite käyttää organisaatiosi kirjautumista. Kirjaudu sisään käyttääksesi Boardmakeria organisaatiosi kautta tai luo uusi tili toisella sähköpostiosoitteella.",
    "federatedEmailUseDifferent": "Käytä toista sähköpostiosoitetta",
    "logIn": "Kirjaudu sisään",
    "logOut": "Kirjaudu ulos",
    "loggingIn": "Kirjautuu sisään...",
    "loggingOut": "Uloskirjautuminen...",
    "verifying": "Tarkistaa...",
    "loggingInMessage": "Sinua kirjataan sisään...",
    "createAccount": "Luo tili",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Onko sinulla jo ",
    "login2": "Tobii Dynavox",
    "login3": "tili",
    "loginPrompt": "Onko sinulla jo <1>Tobii Dynavox -tili</1>? <3>Kirjaudu sisään</3>",
    "cancelSubscription": "Peruuta tilaus",
    "areYouSure": "Haluatko varmasti valita tämän tilaussuunnitelman? Etenee seuraavien kanssa:",
    "cancelSubscriptionProcess": "Peruuta tilauksen toimenpidemenetelmä (nykyinen edistymisesi menetetään)",
    "changeToCommunityPlan": "Vaihda tilisi Yhteisön tilaussuunnitelmaan",
    "onceYouveCompletedYourProfile": "Kun olet täydentänyt profiilisi ja halutessasi versiopäivittää tilaussuunnitelmasi, voit tehdä niin milloin vain Oma tili osassa.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Noutaa käyttäjätietoja"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Täydennä alla olevat tiedot, ja tilin hallinnan päällikkömme ottaa sinuun pian yhteyttä.",
    "fillOutDetailsBelowLicense": "Täydennä alla olevat tiedot, ja toimiva myyntiedustajamme ottaa sinuun pian yhteyttä."
  },
  "forms": {
    "confirmEmail": "Vahvistussähköposti",
    "billingDetails": "Laskutustiedot",
    "paymentType": "Maksun Tyyppi:",
    "creditCardType": "Maksun Tyyppi:",
    "creditCard": "Luottokortti",
    "purchaseOrder": "Hankintatilaus",
    "cardNumber": "Korttinumero",
    "expirationDate": "Vanhenemispäivä",
    "cardholderName": "Kortinhaltijan nimi",
    "cardSecurityCode": "Kortin turvallisuuskoodi",
    "securityCode": "Turvakoodi",
    "organizationName": "Organisaation nimi",
    "accountsPayableEmail": "Ostovelan sähköpostiosoite",
    "firstName": "Etunimi",
    "lastName": "Sukunimi",
    "addressLine": "Osoiterivi 1",
    "addressLine2": "Osoiterivi 2",
    "country": "Maa",
    "language": "Kieli",
    "city": "Kaupunki",
    "stateProvinceRegion": "Osavaltio/Provinssi/Alue",
    "zipPostalCode": "Postinumero",
    "month": "Kuukausi",
    "year": "Vuosi",
    "optional": "valinnainen",
    "username": "Käyttäjätunnus",
    "name": "Nimi",
    "phoneNumber": "Puhelinnumero",
    "phone": "Puhelin",
    "email": "Sähköposti",
    "url": "URL",
    "selectYourCountry": "Valitse maa",
    "selectYourState": "Valitse osavaltiosi.",
    "selectYourProvinceTerritory": "Valitse maakuntasi tai alueesi.",
    "selectYourTerm": "Valitse aikajaksosi",
    "1year": "1 vuosi",
    "2years": "2 vuotta",
    "3years": "3 vuotta",
    "4years": "4 vuotta",
    "5years": "5 vuotta",
    "instructorLogins": "Ohjaajien sisään kirjautumisten lukumäärä",
    "studentLogins": "Opiskelijoiden sisään kirjautumisten lukumäärä",
    "term": "Jakso",
    "tradeIn": "Oletko kelpuutettu vaihtoalennukseen?",
    "legacyVersions": "Onko sinulla Boardmakerin perintöversioita vaihdettavana alennuksen saamiseksi myBoardmaker -version osalta?",
    "selectAResponse": "Valitse vastaus",
    "yes": "Kyllä",
    "no": "Ei",
    "notSure": "Epävarma",
    "password": "Salasana",
    "confirmPassword": "Vahvista salasana",
    "additionalInformationOrQuestions": "Lisätietoja tai kysymyksiä",
    "countryNotSupported": "---",
    "uploadDocument": "Lataa asiakirja",
    "chooseFile": "Valitse tiedosto",
    "paymentMethod": "Maksutapa",
    "purchaseOrdersAreOnlyProcessed": "Hankintatilaukset käsitellään vain, kun tilauksesi on lähetetty, jotta niitä voidaan muokata milloin vain ennen tätä.",
    "PONumber": "Hankintatilausnumero",
    "PONotes": "Organisaation muistiinpanot",
    "iVerifyThatImAuthorized": "Vahvistan, että olen valtuutettu lähettämään tämän ostotilauksen.",
    "submissionSuccessful": "Lähetys onnistui!",
    "thankYourForYourRequest": "Kiitos pyynnöstäsi! Tilipäällikkömme ottaa sinuun yhteyttä piakkoin",
    "ccExpDateFormat": "KK/VVVV",
    "numberOfLicenses": "Lisenssien määrä",
    "pleaseEnterYourName": "Kirjoita nimesi samalla tavoin kuin se on merkitty kortille",
    "needHelpFindingSecurityCode": "Tarvitsetko apua korttisi turvakoodin löytämiseksi"
  },
  "validation": {
    "required": "Vaaditaan",
    "invalidEmail": "Virheellinen sähköposti",
    "emailsMustMatch": "Sähköpostien tulee vastata toisiaan",
    "passwordsMustMatch": "Salasanojen tulee vastata toisiaan",
    "errorOccurred": "Lomaketta lähettäessä tapahtui virhe",
    "tryAgain": "Yritä uudelleen. Jos ongelma jatkuu, ota yhteyttä tukeen.",
    "errorOccurredPDF": "Tapahtui virhe ladattaessa PDF-laskua",
    "password": {
      "minLength": "Salasanassa on oltava vähintään 8 merkkiä",
      "tooShort": "Liian lyhyt",
      "checking": "Tarkistaa..."
    },
    "USZipCode": "On syötettävä USA:n postinumero",
    "CAZipCode": "On syötettävä Kanadan postinumero",
    "invalidCardNumber": "Virheellinen korttinumero",
    "invalidCardType": "Virheellinen korttityyppi",
    "invalidExpirationDate": "Virheellinen päättymispäivä",
    "invalidSecurityCode": "Virheellinen turvallisuuskoodi",
    "securityCodeNumericWarning": "Turvallisuuskoodin tulee sisältää vain numeroita",
    "invalidUsernameWarning": "Käyttäjätunnus ei kelpaa. Salasanan tulee sisältää vain kirjaimia ja numeroita.",
    "usernameMaxLengthWarning": "Käyttäjänimi ei voi olla yli 60 merkkiä pitkä.",
    "badZip": "Syötetty postinumero ei ole kelvollinen syötetyn osavaltion osalta.",
    "badPostalCode": "Syötetty Postinumero ei ole kelvollinen syötetyn maakunnan tai alueen osalta.",
    "canadianAddressNeedsCad": "Kanadalaiset laskutusosoitteet laskutetaan Kanadan dollareina. Jatka valitsemalla sivun yläreunasta lippu ja sitten Kanada."
  },
  "invoice": {
    "communityHeader": "Ei luottokorttia. Vain vapaa pääsy myBoardmaker Community -sisältöön. Pidä tietosi ja etenemisesi, mikäli päätät versiopäivittää maksettuun tilaussuunnitelmaan. Mitä odotat?",
    "trialHeader": "Ei rajoituksia. Ei luottokorttia. Pidä tietosi ja etenemisesi, mikäli päätät muuntaa kokeilujaksosi maksetuksi tilaussuunnitelmaksi. Mitä odotat?",
    "plan": "Suunnittele",
    "term": "Jakso",
    "price": "Hinta",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Maksutiedot",
    "endingWith": "Päättyy",
    "expires": "Vanhenee",
    "orderSummary": "Tilausyhteenveto",
    "orderDate": "Tilauspäivämäärä",
    "orderNumber": "Tilausnumero",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Vero",
    "total": "Yhteensä",
    "aConfirmationEmail": "Sähköposti todentamista varten on lähetetty osoitteeseen",
    "printOrderSummary": "Tulosta tilausyhteenveto",
    "recurringPaymentDisclaimer": "Tilauksesi sisältää <strong>toistuvan maksun</strong> määrältään <3>{{amount}}</3>, joka uusiutuu ajalla <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Veloitamme <strong>{{amount}}</strong> <strong>{{date}}</strong>, kun uusi tilauksesi alkaa.",
    "PODisclaimer": "Tilauksesi on nyt aktiivinen ja valmis käytettäväksi. Välttääksesi keskeytyksiä palvelussasi, meidän on vastaanotettava maksusi <strong>30 päivän kuluessa</strong>. Mikäli maksua ei vastaanoteta <4>{{date, LL}}</4> mennessä, tilisi muunnetaan maksuttomaksi yhteisötiliksi, kunnes maksuerotus on maksettu..",
    "purchaseOrderNumber": "Hankintatilausnumero",
    "orgNotes": "Organisaation muistiinpanot",
    "pleaseSendACopyOfYourInvoice": "Lähetä maksusi ja laskukopiosi osoitteeseen:",
    "ifYourPurchaseOrdersReady": "Jos hankintatilauksesi on valmis, voit ladata sen nyt.",
    "supportedFileTypes": "Tuetut tiedostotyypit: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " Kun aika koittaa, lähetämme sähköpostin osoitteeseen <1>{{email}} muistuttaen sinulle, milloin seuraava maksusi on erääntymässä.",
    "uploadSuccessful": "Päivitys onnistui!",
    "yourAccountWillContinue": "Kiitos hankintatilauksestasi. Tilaussopimusten uudistusten osalta, salli 14 tilauksesi käsittelyä varten. Kun valmis, vastaanotat sähköpostivahvistuksen päätöksestä laskusi ohella.",
    "billing": "Laskutusosoite",
    "payment": "Maksutapa",
    "ifYourPurchaseOrderIsReady": "Jos hankintatilauksesi on valmis, voit ladata sen nyt.",
    "PODisclaimer1": "Tilauksesi on nyt aktiivinen ja valmis käytettäväksi.",
    "PODisclaimer2": "Maksu tulee vastaanottaa 30 päivän kuluessa tai tilisi muuntuu automaattisesti maksuttomaksi yhteisötiliksi.",
    "POStartsLaterDisclaimer": "Lähetämme laskusi <strong>{{date}}</strong>, kun uusi tilauksesi alkaa. Maksu erääntyy 30 päivän kuluessa tästä päivästä."
  },
  "legal": {
    "privacyPolicy": "Tietosuojamenettely",
    "studentPolicy": "Opiskelijoiden tietosuojakäytäntö",
    "termsAndConditions": "Ehdot",
    "termsOfService": "Palvelun ehdot",
    "tdTermsAndConditions": "Hyväksyn Tobii Dynavox <1>$t(legal.termsAndConditions)</1>",
    "contactUs": "Ota yhteyttä"
  },
  "errors": {
    "error": "Virhe",
    "loadingPlans": "Lataa suunnitelmia",
    "sorry": "Pahoittelemme... kyseessä et ole sinä... meillä on ongelma",
    "somethingWentWrong": "Jotain meni vikaan meidän puolellamme. Olemme kirjanneet tämän virheen ja kehotamme sinua <1>{{link}}</1>, mikäli kohtaat tämän ongelman uudelleen.",
    "tryGoingBack": "Yritä siirtyä takaisin tai  <1>{{link}}</1>",
    "downloadList": "Latausluetteloa ei voitu ladata."
  },
  "404": {
    "sorry": "Pahoittelemme... emme voineet löytää kyseistä sivua",
    "oldLink": "Kyseessä saattaa olla vanha linkki tai se on siirretty.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Aloita maksuton kokeilujaksosi välittömästi!",
    "startYourFreeTrial": "Aloita maksuton kokeilujaksosi",
    "todayWhichIncludesAccessForThirtyDays": " välittömästi, joka sisältää pääsyn 30 päivän ajaksi!"
  },
  "navigation": {
    "bmoRedirect": "Ohjataan uudelleen myBoardmaker -sivustolle..."
  },
  "expired": {
    "expiredTrialText": "Toivomme, että nautit 30 päivän rajattomasta esikatselusta. Kokeilujaksosi on muunnettu maksuttomaksi Yhteisön tilaussunnitelmaksi ja kaikki tietosi ja eteneminen* on tallennettu. Siirtyäksesi ensisijaisiin ominaisuuksiin, jotka ovat saatavina kokeilujaksosi aikana, yksinkertaisesti versiopäivitä kuukausittaiseen tai vuosittaiseen tilaukseen.",
    "dataAndProgress": "* Tiedot ja eteneminen, jotka ovat sisällytettyjä ensisijaisiin ominaisuuksiin, ovat vain saatavina täydessä maksullisessa tilaussuunnitelmassa."
  },
  "currencySelector": {
    "header": "Valitse maasi ja kielesi",
    "disclaimer": {
      "USD": "Mikäli maatasi ei ole luetteloitu, valitse Yhdysvallat"
    }
  },
  "taxExempt": {
    "us&ca": "Vain Yhdysvallat ja Kanada",
    "taxExemptionProgram": "Lähetä verovapaat asiakirjasi tätä lomaketta käyttämällä. Otamme sinuun yhteyttä sähköpostitse 3 arkipäivän kuluessa vahvistaaksemme verovapaan tilasi. Vastaanotettuasi vahvistussähköpostin, voit jättää verovapaan tilauksesi. Mikäli asetat tilauksesi ennen vahvistussähköpostin vastaanottamista, sinulta veloitetaan palauttamaton vero.",
    "taxExemptionProgramExisting": "Lähetä verovapaat asiakirjasi tätä lomaketta käyttämällä. Otamme sinuun yhteyttä sähköpostitse 3 arkipäivän kuluessa vahvistaaksemme verovapaan tilasi. Vastaanotettuasi hyväksyntäsähköposti, tulevaisuuden hankinta ja tilaussuunnitelmien uudistukset eivät ole veronalaisia. Hankinnoista maksetut verot, jotka ovat suoritettuja ennen verovapauden vahvistussähköpostin vastaanottamista, eivät ole hyvitettävissä.",
    "yourSubmissionWasSuccessfulNew": "Lähetyksesi onnistui. Henkilöstömme tarkastaa asiakirjasi ja vastaanotat sähköposti-ilmoituksen 3 liiketoimintapäivän kuluessa varmistaen, että hakemuksesi käsiteltiin. Kun hyväksytty, voit viedä päätökseen tilauksesi verovapaasti. Samaan aikaan, olemme luoneet maksuttoman Yhteisötilin sinua varten, voidaksesi tutkia kaikkea mitä myBoardmaker -sisällöllä on tarjottavanaan.",
    "yourSubmissionWasSuccessfulExisting": "Lähetyksesi onnistui. Henkilöstömme tarkastaa asiakirjasi ja vastaanotat sähköposti-ilmoituksen 3 liiketoimintapäivän kuluessa varmistaen, että hakemuksesi käsiteltiin. Kun hyväksytty, voit suorittaa seuraavan maksusi verottomasti."
  },
  "modify": {
    "contactCustomerSupport": "Ota yhteyttä <1>{{supportLink}}</1> muokataksesi tilaustasi",
    "billingDetails": "Laskutustietojen muuttaminen",
    "paymentModalHeader": "Päivitys onnistui!",
    "paymentModalBody": "Muutoksesi ovat näkyvillä seuraavassa laskutusjaksossa.",
    "thankYou": "Kiitos maksustasi!",
    "daysRemaining": "päivää jäljellä",
    "dueDisclaimer": "Mikäli maksua ei vastaanoteta  30 päivän uusiutumispäivämäärästäsi, tilisi muunnetaan automaattisesti maksuttomaksi yhteisötiliksi, kunnes maksuerotus on maksettu.",
    "lateDisclaimer": "Välttääksesi tilauksesi keskeytymisen, maksa maksusi täysimittaisesti. Mikäli maksua ei vastaanoteta , tilisi muunnetaan automaattisesti maksuttomaksi yhteisötiliksi, kunnes maksuerotus on maksettu.",
    "nextPaymentDueIn": "Seuraavan maksun eräpäivä on",
    "days": "päivää",
    "paymentIs": "Maksu on",
    "daysPastDue": "päivää myöhässä",
    "recurringPaymentDisclaimer": "<1>planOrOrder</1> sisältää <strong>toistuvan maksun</strong> määrältään <4>{{amount}}</4>, joka uusiutuu <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Tilaussuunnitelmasi sisältää <strong>toistuvan maksun</strong>, joka uusiutuu ajalla <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "Voit lähettää hankintatilauksesi käyttämällä yhtä alla mainituista toimenpidemenetelmistä. Ota yhteyttä asiakastukitiimiin aktivoidaksesi uudelleen tilauksesi.",
    "yourAccountHasBeenConverted": "Maksullinen tilisi on muunnettu maksuttomaksi yhteisötiliksi",
    "balanceDueIn": "Velkasaldo erääntyy ajalla",
    "subscriptionExpiresIn": "Tilaussuunnitelma vanhenee ajalla",
    "paymentPastDue": "Maksu on myöhässä",
    "autoRenewal": "Automaattinen uudistus",
    "turnAutoRenewOff": {
      "header": "Poista tilaussuunnitelman automaattinen uudistus käytöstä",
      "areYouSure": "Haluatko varmasti poistaa automaattisen uudistuksen käytöstä? Etenee seuraavien kanssa:",
      "points": [
        "Keskeytä maksettu tilaussuunnitelmasi nykyisen laskutuskauden lopussa.",
        "Muunna maksettu tilaussuunnitelmasi maksuttomaksi Yhteisö-tilaussuunnitelmaksi nykyisen laskutuskauden lopussa.",
        "Sinulla on pääsy sisältöösi muunnon jälkeen ja voit tilata uudelleen milloin päästäksesi uudelleen ensisijaisiin ominaisuuksiin, jotka toimitetaan maksettuihin tilaussuunnitelmiin.",
        "Mikäli muutat mielesi ennen nykyisen tilaussuunnitelmasi päättymistä, kytke yksinkertaisesti päälle automaattinen uudelleen tilaus."
      ],
      "footer": "Haluatko poistaa automaattisen uudistuksen käytöstä?"
    },
    "turnAutoRenewOn": {
      "header": "Ota käyttöön tilaussuunnitelman automaattinen uudistus",
      "areYouSure": "Automaattisen tilaussuunnitelman uudistuksen ominaisuudet:",
      "points": [
        "Tilausksesi on asetettu uudistumaan automaattisesti nykyisen tilausuunnitelmajakson päättyessä.",
        "Ongelmaton maksu käyttämällä tallennettua maksutapaasi.",
        "Lähetämme sinulle kuitin aina tilauksesi uudistuessa.",
        "Kuten aina, voit muuttaa tilausasetuksiasi milloin Oma tilaussuunitelma -sisällössä.",
        "Muutitko mielesi? Poista käytöstä automaattinen uudelleen tilaus ennen viimeisen päivän päätymistä nykyisessä tilausjaksossa, etkä vastaanota laskua."
      ],
      "footer": "Haluaisitko ottaa käyttöön automaattisen uudistuksen?"
    },
    "on": "Päällä",
    "off": "Pois päältä",
    "pending": "odottaa",
    "plan": "Suunnittele",
    "term": "Jakso",
    "effective": "Voimaantulopäivä:",
    "subscription": "Tilaus",
    "downgradeWarning": {
      "title": "Tilaussuunnitelman päivitys",
      "prompt": "Haluatko varmasti valita tämän tilaussuunnitelman? Etenee seuraavien kanssa:",
      "planChange": "Päivitä tilaussuunnitelmasi Ammattimaisesta Henkilökohtaiseksi nykyisen laskutusjaksosi päätteeksi",
      "termChange": "Päivitä aikajaksosi vuosittaisesta kuukausittaiseksi nykyisen laskutusjaksosi päätteeksi",
      "changeNote": "Muutoksesi ovat näkyvillä seuraavassa laskutusjaksossa.",
      "termChangeMultiToYearly": "Päivitä monivuotinen jakso vuosittaiseksi jaksoksi nykyisen laskutusjaksosi päätteeksi",
      "termChangeMultiToMonthly": "Päivitä monivuotinen jakso kuukausittaiseksi jaksoksi nykyisen laskutusjaksosi päätteeksi"
    },
    "futureAmendmentThankYou": "Nämä muutokset tulevat voimaan nykyisen laskutusjakson päättyessä. Lasku tulee olemaan saatavana, kun nämä muutokset otetaan käyttöön tililläsi. Jos haluat muuttaa odottavaa muutosta, ota yhteyttä <1>asiakastukeen</1>.",
    "futureAmendmentDisclaimer": "Nykyinen <1>{{planName}}</1> tilaussuunnitelmasi vanhenee ajalla <3>{{startEndDate}}</3>. Uusi <5>{{selectedPlanName}}</5> tilaussuunnitelmasi alkaa ajalla <7>{{startEndDate}}</7> ja uusiutuu automaattisesti <9>{{term}}</9>.",
    "modificationPending": "Tilaussuunnitelman muutoksia vahvistettavana",
    "paymentDeclined": "Tilaussuunnitelmasi uudistustapahtuma hylättiin. Muuta maksutapojasi <1>{{date}}</1> mennessä tai tilaussuunnitelmasi peruutetaan.",
    "continueSubscription": "Tilauksesi vanhenee ajalla <1>{{ date1 }}</1>. Jos haluat jatkaa tilaussuunnitelmaasi kertaalleen {{term}}, kytke päälle automaattinen uudistus ajalla <5>{{ date2 }}</5> ja me käsittelemme maksusi seuraavana päivänä.",
    "discontinuedRatePlan": "Nykyinen tilaussuunnitelmasi ei ole enää saatavana. Valitse toinen vaihtoehto.",
    "cancelYourSubscription": "Jos haluat peruuttaa tilaussuunnitelmasi ja vastaanottaa täyden hyvityksen, ota yhteyttä ennen <1>{{supportLink}}</1> <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Muokkaa tilausta",
    "cancelCardText": "Voit peruuttaa tilauksesi milloin tahansa. Mutta toivoisimme sinun jäävän asiakkaaksemme.",
    "cancelConfirmTitle": "Haluatko varmasti peruuttaa tilauksesi?",
    "cancelConfirmIntro": "Nykyinen tilaussuunnitelmasi pysyy voimassa <strong>{{date}}</strong> asti. Kun tilaussuunnitelmasi päättyy:",
    "cancelConsequences": [
      "Menetät pääsyn premium-ominaisuuksiin.",
      "Menetät tilaukseesi kuuluvat yksinoikeusedut.",
      "Tilauksesi edut päättyvät, kun nykyinen tilaussuunnitelmasi päättyy."
    ],
    "keepSubscription": "Säilytä tilaukseni",
    "confirmCancel": "Ei, haluan peruuttaa",
    "cancelledTitle": "Tilauksesi on peruutettu!",
    "cancelledBody": "Tilauksesi on peruutettu. Sinulla ei ole pääsyä premium-tiliisi {{date}} jälkeen.",
    "cancelledFarewell": "Harmi, että lähdet! Olet aina tervetullut takaisin.",
    "done": "Valmis",
    "cancelledNotice": "Nykyinen <strong>{{planName}}</strong>-tilauksesi päättyy <strong>{{date}}</strong>. Uusi tilauksesi jatkaaksesi premium-ominaisuuksiemme käyttöä.",
    "resubscribedNotice": "Uusi <strong>{{planName}}</strong>-tilauksesi alkaa <strong>{{date}}</strong>, kun nykyinen tilauksesi päättyy."
  },
  "tdAccount": {
    "title": "Tobii Dynavox -tili",
    "header": "Mikä on Tobii Dynavox Single Sign On (SSO) -tili?",
    "body": "Tobii Dynavox SSO -tilisi koostuu sähköpostiosoitteesta ja salasanasta, on yksittäinen tili, jolla kirjaudutaan kaikille verkkosivuillemme ja sovelluksiimme. Lisättyjen turvallisuuden hyötytekijöiden ohella, SSO toimittaa nopeamman ja helpomman pääsyn sisältöihisi kaikissa Tobii Dynavox -palveluissa.",
    "haveA": "Pidä",
    "tobiiDynavoxAccount": "Tobii Dynavox -tili?"
  },
  "redirectPageTitle": {
    "homePage": "Kotisivu",
    "profileCreation": "Profiilin luonti"
  },
  "download": {
    "downloadBoardmaker": "Lataa Boardmaker",
    "downloadBoardmakerStudentCenter": "Lataa Boardmaker Student Center",
    "downloadOtherVersions": "Lataa muut versiot",
    "downloadBoardmakerStudio": "Lataa Boardmaker Studio",
    "licenseKey": "Lisenssiavain",
    "download": "Lataa",
    "licenseHelper": "Lisenssiavustin",
    "discontinued": "Keskeytetty <1>{{discontinueDate}}</1>. Ks. <3>järjestelmävaatimukset</3>.",
    "communityStartHeader": [
      "Lunasta yhteisön käyttöoikeutesi ja tallennustilasi",
      0,
      0
    ],
    "communityStartBody": [
      "Boardmaker on suunniteltu toimimaan Boardmakeronline.com kanssa, jossa voit turvallisesti varmuuskopioida Boardmaker-tiedostot ja siirtyä globaaliin yhteisöön. Yhteisön jäsenet voivat jakaa, mitä he ovat luoneet ja löytää uusia Boardmakerin aktiviteetteja muilta käyttäjiltä. Kirjaudu käyttäjäksi maksuttomalle Yhteisötilille vastaanottaaksesi pääsyn!",
      0,
      0
    ],
    "latestMobile": "Parasta kokemusta varten, pyri lataamaan ohjelmisto laitteelta, joka täyttää <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "järjestelmävaatimukset",
    "viewSystemRequirements": "Katso <1>{{guideLink}}</1> järjestelmävaatimukset.",
    "onThisPage": "Tällä sivulla",
    "communityStart": {
      "header": "Lunasta yhteisön käyttöoikeutesi ja tallennustilasi",
      "body": "Boardmaker on suunniteltu toimimaaan myboardmaker.com kanssa. Maksuton Boardmaker-yhteisötilisi sisältää:",
      "pointOne": "Pilvitallennustila - varmuuskopioi henkilökohtaiset Boardmaker-tiedostosi ja siirry niihin mistä vain!",
      "pointTwo": "Activities-to-Go - tasattu, temaattinen oppisuunnitelma, joka on valmis tulostettavaksi ja käytettäväksi.",
      "pointThree": "Siirry globaaliin yhteisöömme, jaa mitä olet luonut ja löydä uusia Boardmakerin aktiviteetteja muilta käyttäjiltä.",
      "footer": "Kirjaudu käyttäjäksi maksuttomalle Yhteisötilillesi vastaanottaaksesi pääsyn!"
    },
    "BoardmakerCompatible": "Tämä laite ei ole yhteensopiva Boardmaker-ohjelmiston kanssa",
    "BoardmakerStudentCenterCompatible": "Tämä laite ei ole yhteensopiva Boardmaker Student Center -sovelluksen kanssa.",
    "BoardmakerMobile": "Boardmaker-sovelluksia ei tueta tällä laitteella.",
    "mainFeatures": "Pääasialliset ominaisuudet",
    "compatibility": "Yhteensopivuus",
    "improvements": "Parannukset",
    "bugFixes": "Virhekorjaukset",
    "version": "Versio",
    "discontinuedSupport": "Päättynyt tuki",
    "releaseDate": "Julkistanut {{date}}",
    "discontinuedDate": "Keskeytetty {{date}}",
    "boardmakerSummary": "Valitse alla oleva painike ladataksesi viimeisimmän Boardmaker Editorin version, jota käytetään aktiviteettien luonnissa ja muokkaamisessa.  Asennin toimii kaikissa tilityypeissä ja tuetuissa kielissä.",
    "studentCenterSummary": "Valitse alla oleva painike ladataksesi viimeisimmän Boardmaker Student Centerin, jota käytetään Boardmaker-aktiviteettien toistamiseen. Asennin toimii kaikissa tilityypeissä ja tuetuissa kielissä.",
    "boardmakerIntro": "Boardmaker 7 Editor on ensisijainen työkalu, jonka avulla opettajat, terapeutit ja vanhemmat voivat luoda, muokata ja jakaa Boardmaker-toimintoja.  Tue oppimista ja viestintää luokkahuoneessa, terapiahuoneessa tai kotona mukautettavan materiaalin avulla.",
"studentCenterIntro": "Kun Boardmaker 7 on yhdistetty tietyntyyppisiin Boardmaker 7 -tilauksiin, opettajat voivat määrittää oppilaille tehtäviä Boardmaker 7 Student Center -sovelluksessa ja seurata heidän edistymistään.  Oppilaat voivat käyttää sovellusta kotona tai koulussa tehtäviensä suorittamiseen.",
"boardmakerStudioIntro": "Boardmaker Studion avulla vammaisia oppilaita tukevat henkilöt voivat luoda ja muokata toimintoja, jotka auttavat oppilaita oppimaan ja viestimään symboleiden, tekstin sekä synteettisen ja äänitetyn puheen avulla.",
"mobilePlayerIntro": "Kun myBoardmaker on yhdistetty tietyntyyppisiin Boardmaker 7 -tilauksiin, opettajat voivat määrittää oppilaille tehtäviä Boardmaker Student Center -sovelluksessa ja seurata heidän edistymistään.  Oppilaat voivat käyttää sovellusta kotona tai koulussa tehtäviensä suorittamiseen."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "tilaus",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "lisenssi",
      "tolicenseText": "kertaluontoinen hankinta",
      "mainText": "Suositko <1>{{ toggleText }}</1> tai <3>{{ helpLink }}</3>?",
      "preferencedText": "Suosi "
    },
    "comparison": {
      "accessTo": "Siirry seuraavaan...",
      "title": "Auta minua valitsemaan",
      "titleDescription": "Nopea vilkaisu myBoardmaker -tilaussuunnitelmaan ja Boardmaker-ohjelmaan itseensä.",
      "titles": {
        "investment": "Investointi",
        "includedSoftware": "Sisällytetty ohjelmisto",
        "softwareUpdates": "Ohjelmistopäivitykset",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Cloud -tallennustila",
        "curriculum": "Kurssi",
        "studentManagement": "Opiskelijahallinta"
      },
      "subscription": {
        "header": "Boardmaker Online -tilaus",
        "investment": "Alhainen aloitusmaksu, vuosittaiset tai kuukausittaiset maksuvaihtoehdot",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Sisällytetty (2 - 3 kertaa vuodessa)",
        "pcsSymbols": "Kaikki symbolit, mukaan lukien uudet symbolit joka 2 viikko",
        "cloudStorage": [
          "Aktiviteettien tallennustila",
          "Median tallennustila"
        ],
        "curriculum": [
          "Boardmaker Activities to Go 10 Themes x 4 Units each",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": [
          "Määritä aktiviteetit\u00B9",
          "Jäljitä suoritusta"
        ]
      },
      "license": {
        "header": "Vain ohjelmisto",
        "investment": "Kertaluontoinen ohjelmiston hankinta",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Maksulliset versiopäivitykset ajoittain (joka 2-3 vuoden välein)",
        "pcsSymbols": "Kaikki symbolit saatavina viimeisen julkaisun aikaan (PCS-tilaus tulossa pian)",
        "cloudStorage": ["Aktiviteettien tallennustila"],
        "curriculum": [
          "Boardmaker aktiviteetteja mukaan otettaviksi 1 teema x 4 yksikköä"
        ],
        "studentManagement": ["Ei ole"]
      },
      "note": "Käyttäjät voivat hallita ja lisätä tehtäviä yksittäisille opiskelijoille Ammattimaisessa tilaussuunnitelmassa",
      "note2": "Voidaan siirtyä vain Student Center Playerin avulla",
      "note3": "Käyttäjät voivat hallita ja lisätä tehtäviä yksittäisille opiskelijoille Ammattimaisessa tilaussuunnitelmassa",
      "localizationNoteOne": "Boardmaker 7 -sovellukset ovat saatavina seuraavilla kielillä sekä tilaaville, että jatkuville (vain ohjelmisto) käyttäjille",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Englanti (USA)",
        "Espanja",
        "Saksa",
        "Ruotsi",
        "Suomi",
        "Venäjä",
        "Tanska",
        "Norja",
        "Ranska",
        "Italia",
        "Puola",
        "Portugali"
      ],
      "localizationNoteTwo": "Oppisuunnitelma, sekä myBoardmaker.com -verkkosivusto ovat saatavina vain englannin kielisinä."
    }
  },
  "systemRequirements": "Järjestelmän vaatimukset",
  "releaseNotes": "Julkaisutiedot",
  "operatingSystem": {
    "title": "Käyttöjärjestelmä",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobiili)",
    "windows": "Windows",
    "unknown": "Tuntematon"
  },
  "perpetual": {
    "trial": {
      "intro": "Ei luottokorttia. Ei sitoumusta. Vain <1>{{trialLength}}</1> perättäistä päivää rajoittamattomalla pääsyllä viimeisimpään Boardmaker-ohjelmistoon. Ladattuasi ja asennettuasi ohjelmiston tietokoneellesi, voit pyytää  <3>{{trialLength}}</3>-päivän aktivointiavainta <5>*</5> ohjelmistosta.",
      "footnote": "<0>*</0>Kokeilujaksot alkavat päivänä, jolloin ohjelmistomme on aktivoitu ja pysyvät aktiivisina <2>{{trialLength}}</2> perättäisen päivän ajan.",
      "downloadFootnote": "<0>v{{version}}</0> sisältää viimeisimmät ominaisuudet ja korjaustiedostot. Ks. <2>järjestelmävaatimukset</2>."
    },
    "thankyou": {
      "intro": "Tarkastele tilausvahvistussähköpostiasi, joka sisältää Boardmakerin latauslinkit ja aktivointiavaimesi. Olemme myös toimittaneet tiedot alla olevassa. Lataa ja asenna Boardmaker tietokoneellesi, käytä sitten aktivointiavainta aktivoidaksesi ohjelmistosi. Aktivoinnin tapahduttua, vastaanotat 1 vuoden ajan maksuttomia päivityksiä. <1>Varmista että tallennat aktivointiavaimen tulevaisuuden käyttöä varten.</1>"
    },
    "latest": "Viimeisin",
    "legacy": "Legacy"
  },
  "countries": {
    "us": "Amerikan Yhdysvallat"
  },
  "currencyChange": {
    "header": "Valuuttamuutos",
    "body": "Tähän aikaan, tilaussuunnitelmia ei voida ostaa käyttäen valuuttaa valitusta maastasi. Eteneminen muuntaa valuuttasi Yhdysvaltain dollareiksi - USD."
  },
  "partner": {
    "body": "Valittu kumppani tai tukitoimittaja, tulee olemaan ensisijainen yhteystahosi kaikissa tuotteisiin liittyvissä kysymyksissä ja teknisissä ongelmissa.",
    "contactUs": "Mikäli merkitty maa ei ole oikea, ",
    "contactCustomerService": "ota yhteyttä asiakaspalveluun."
  }
}
